import { Pixall } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from '@/analytics/utilities';
/**
 * @summary Sends Pixall event when clicking vehicle condition highlights section
 */
export function inventoryVehicleConditionHighlightsClick(metadata, option) {
    const { data = {}, dataLayer = {}, state } = metadata;
    const { inventoryId, ...restPixallData } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);

    Pixall.sendClickEvent({
        eventSource: 'userAccount',
        label: 'text-link::vehicle-condition-highlights',
        inventory,
        pixallData: { clickTypeToListingType: true },
        ...restPixallData,
    }, dataLayer, option);

    return {};
}
